import React, { useEffect, useState } from 'react';

import { useAtom } from 'jotai';
import InfiniteScroll from 'react-infinite-scroll-component';

import { GetDiscussionsByUser } from '@/api/fetch/marketplace-api';
import {
  DiscussionResponse,
  GetDiscussionsResponse,
  UserRequest,
} from '@/api/gen-protos/messenger_pb';
import { stickyBannerAtom } from '@/lib/store';
import Messages from '@/modules/core/components/Chat/Messages';
import {
  AuthTokenAtom,
  UserDataAtom,
} from '@/modules/core/store/grpc-free-store';

function secondsToTimeString(seconds: number) {
  return new Date(seconds * 1000).toLocaleDateString();
}

const MessagesTab = () => {
  const [haseMore, setHaseMore] = useState(true);
  const [count, setCount] = useState(0);
  // @ts-ignore
  const [userData] = useAtom(UserDataAtom);
  const [isLoading] = useState(false);
  const [discussionId, setDiscussionId] = useState<string>('');
  const [userName, setUserName] = useState<string | undefined>('');
  const [poster, setPoster] = useState<string | undefined>('');
  const [userAvatar, setuserAvatar] = useState<string | undefined>('');
  const [adTitle, setAdTitle] = useState<string | undefined>('');
  const [userId, setUserId] = useState<string | undefined>('');
  const [secondUser, setSecondUser] = useState<string | undefined>('');
  const [adId, setAdID] = useState<string | undefined>('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [authToken] = useAtom(AuthTokenAtom);
  const [discussions, setDiscussions] = useState<DiscussionResponse[]>([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [stickyBar] = useAtom(stickyBannerAtom);

  function closeModal() {
    setIsModalVisible(false);
  }

  const isSmallScreen =
    typeof window !== 'undefined' && window.innerWidth < 1024;

  const GetDiscussions = async (init: boolean) => {
    if (userData?.kcid) {
      const userRequest = new UserRequest();
      userRequest.setKcid(userData?.kcid);
      userRequest.setSkip(init ? 0 : discussions?.length);
      userRequest.setLimit(10);
      GetDiscussionsByUser(authToken, userRequest).then(
        async (res: GetDiscussionsResponse) => {
          if (res && res.getDiscussionsList().length > 0) {
            setCount(res.getCountdisscussion());
            await setDiscussions((prevDiscussions) => [
              ...(prevDiscussions as DiscussionResponse[]),
              ...res.getDiscussionsList(),
            ]);
          } else {
            setHaseMore(false);
          }
        }
      );
    }
  };
  useEffect(() => {
    GetDiscussions(true).then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.kcid]);

  const handleUpdateDiscussionId = (
    id: string,
    useravatar: string | undefined,
    username: string | undefined,
    adtitle: string | undefined,
    adid: string | undefined,
    index: number,
    userid: string | undefined,
    secondU: string | undefined,
    po: string | undefined
  ) => {
    setDiscussionId(id);
    setuserAvatar(useravatar);
    setUserName(username);
    setAdTitle(adtitle);
    setAdID(adid);
    setSelectedIndex(index);
    if (userid === userData?.kcid) {
      setUserId(secondU);
    } else {
      setUserId(userid);
    }
    setSecondUser(secondU);
    setPoster(po);
  };

  const LoadMoreDiscussions = async () => {
    await GetDiscussions(false);
  };

  if (!discussions)
    return <p className={'text-primary'}>No discussions data</p>;
  return (
    <div className={`w-full`}>
      <div className="w-full border rounded lg:grid lg:grid-cols-3">
        <div className="border-r border-gray-300 lg:col-span-1">
          <div className="mx-3 my-3">
            <div className="relative text-gray-600">
              <span className="absolute inset-y-0 left-0 flex items-center pl-2"></span>
            </div>
          </div>

          <ul
            className="overflow-y-scroll  h-[100vh] lg:h-[42rem]"
            id={'scrollableDiv'}
          >
            <h2 className="my-2 mb-4 ml-2 text-lg text-gray-600">
              Discussions ( {count} )
            </h2>
            {isLoading ? (
              <svg
                role="status"
                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            ) : (
              <InfiniteScroll
                scrollThreshold={1}
                dataLength={discussions?.length}
                next={() => LoadMoreDiscussions()}
                hasMore={haseMore}
                loader={''}
                endMessage={
                  <p className="p-4 text-base text-gray-600  ">
                    Il n{`'`}y a plus de messages à consulter!
                  </p>
                }
                scrollableTarget={'scrollableDiv'}
              >
                <li>
                  {discussions?.map((key, index) => {
                    const adPicture =
                      key.getDiscussion()?.getAd()?.getId() !== 'no-ad'
                        ? key.getDiscussion()?.getAd()?.getPicture() || ''
                        : '/media/t-logo-primary.png';
                    return (
                      <>
                        <a
                          onClick={() => {
                            handleUpdateDiscussionId(
                              key.getId(),
                              key
                                .toObject()
                                .discussion?.membersList[0]?.profilepicture.toString(),
                              key.toObject().discussion?.membersList[0]
                                ?.fullname,
                              key
                                .getDiscussion()
                                ?.getAd()
                                ?.getTitle()
                                .toString(),
                              key.getDiscussion()?.getAd()?.getId(),
                              index,
                              key
                                .toObject()
                                .discussion?.membersList[0]?.kcid.toString(),
                              key
                                .toObject()
                                .discussion?.membersList[1]?.kcid.toString(),
                              key.getDiscussion()?.getAd()?.getUserid()
                            );
                            setIsModalVisible(true);
                          }}
                          key={key.getId()}
                          className={`flex items-center px-3 py-2 text-sm transition duration-150 ease-in-out
                      border-b border-gray-300 cursor-pointer hover:bg-sky-100 focus:outline-none
                      ${selectedIndex === index ? 'bg-sky-100 active' : ''}`}
                        >
                          <img
                            className="object-cover w-10 h-10 rounded-full"
                            src={
                              adPicture === '/media/t-logo-primary.png'
                                ? '/media/t-logo-primary.png'
                                : adPicture?.includes('http')
                                ? `https://www.tayara.tn/mediaGateway/resize-image?img=${adPicture.substring(
                                    adPicture.lastIndexOf('/') - 2
                                  )}&w=300`
                                : `https://www.tayara.tn/mediaGateway/resize-image?img=${adPicture}&w=300`
                            }
                            alt={`ad's image of ${key
                              .getDiscussion()
                              ?.getAd()
                              ?.getTitle()} on tayara`}
                          />
                          <div className="w-full pb-2">
                            <div className="flex justify-between">
                              <span className="block ml-2 font-semibold text-gray-600">
                                {key.getDiscussion()?.getAd()?.getTitle()}
                              </span>
                              <span className="block ml-2 text-sm text-gray-600">
                                {secondsToTimeString(
                                  Number(
                                    key.toObject()?.discussion?.lastmessagedate
                                      ?.seconds
                                  )
                                )}
                              </span>
                            </div>
                            <span className="block ml-2 text-sm text-gray-600">
                              {
                                key.toObject().discussion?.membersList[0]
                                  ?.fullname
                              }
                              {' : '}
                              {key.getDiscussion()?.getLastmessagepreview()}
                            </span>
                          </div>
                        </a>
                      </>
                    );
                  })}
                </li>
              </InfiniteScroll>
            )}
          </ul>
        </div>
        {isSmallScreen && isModalVisible ? (
          <div className="fixed h-full inset-0 z-10 overflow-y-auto">
            <div
              className={`flex justify-center ${
                stickyBar ? 'mt-[8.5rem]' : 'mt-[2.5rem]'
              } h-[100vh] mt-[8.5rem] lg:mt-[2.5rem]`}
            >
              {/* Background overlay */}
              <div
                className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
                aria-hidden="true"
              />

              {/* Modal content */}
              <div className="w-full h-full inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all  sm:align-middle ">
                <div className="bg-white ">
                  <div className=" mt-3 text-gray-500">
                    <Messages
                      closeModal={closeModal}
                      discussionId={discussionId}
                      userAvatar={userAvatar}
                      userName={userName}
                      titre={adTitle}
                      adid={adId}
                      userkcid={userId}
                      seconduser={secondUser}
                      poster={poster}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className=" hidden lg:col-span-2 lg:block">
            <div className="w-full">
              <Messages
                closeModal={closeModal}
                discussionId={discussionId}
                userAvatar={userAvatar}
                userName={userName}
                titre={adTitle}
                adid={adId}
                userkcid={userId}
                seconduser={secondUser}
                poster={poster}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagesTab;
